(function() {
    angular
        .module('ngmvac')
        .directive('fallbackImg', FallbackImg);

    function FallbackImg() {

        var ApiURLImages = {
            'normal': 'https://photos.hotelbeds.com/giata/',
            'medium': 'https://photos.hotelbeds.com/giata/medium/',
            'bigger': 'https://photos.hotelbeds.com/giata/bigger/'
        };

        return {
            restrict: 'A',
            scope: {
                images: '='
            },
            link: function(scope, element, attrs) {
                scope.$watch(function() { return scope.images }, function(newImages) {                  
                    if (angular.isDefined(newImages)) {
                        switch(attrs.imgType) {
                            case 'mini':
                                element.on('error', function() {
                                    element.remove();
                                });
                                break;
                            case 'main':
                                var count = 0;
                                var genImages = [];
                                angular.forEach(newImages, function(img) {
                                    // if(img.imageTypeCode == 'GEN' && img.order == 1 || img.imageTypeCode == 'GEN'){
                                        if(img.path != '64/641001/641001a_hb_a_006.JPG' 
                                        && img.path != '45/459221/459221a_hb_w_005.jpg'
                                        && img.path != '45/459221/459221a_hb_w_008.jpg')
                                        genImages.push(img);
                                        
                                    // }
                                });

                                if( genImages.length == 0 ) {
                                    genImages = newImages;
                                }

                                var src = ApiURLImages.normal + genImages[0].path;
                                if (typeof attrs.item !== undefined) {
                                    if (attrs.item == 'auto') {
                                        src = genImages[0].path;
                                    }
                                }

                                element[0].src = src;

                                element.on('error', function() {
                                    count++;
                                    if( count < genImages.length ) {
                                        element[0].src = ApiURLImages.normal + genImages[count].path;
                                        console.log('Se le asignara otro src: ' + genImages[count].path);
                                    } else {
                                        element[0].src = 'https://mexicovacations.com.mx/img/mvac_no-image.jpg';
                                    }
                                    
                                });
                                break;
                            case 'slider':
                                element.on('error', function() {
                                    element.parent().remove();
                                });
                                break;
                            
                            case 'room2019':
                            break;

                            case 'rooms':
                                var count = 0;
                                var genImages = [];
                                var img_size;
                                
                                if(attrs.imgSize == 'bigger')
                                    img_size = ApiURLImages.bigger;
                                else
                                    img_size = ApiURLImages.normal;
                                console.log(newImages);
                                angular.forEach(newImages, function(img) {
                                    if( img.imageTypeCode == 'HAB' ){
                                        genImages.push(img);
                                    }
                                });

                                if( genImages.length == 0 ) {
                                    angular.forEach(newImages, function(img) {
                                        if( img.imageTypeCode == 'GEN' ){
                                            genImages.push(img);
                                        }
                                    });

                                    if(genImages.length == 0)
                                        genImages = newImages;
                                }

                                var src = img_size + genImages[0].path;
                                if (typeof attrs.item !== undefined) {
                                    if (attrs.item == 'auto') {
                                        src = genImages[0].path;
                                    }
                                }

                                element[0].src = src;
                                element.on('error', function() {
                                    count++;
                                    if( count < genImages.length ) {
                                        element[0].src = img_size + genImages[count].path;
                                        console.log('Se le asignara otro src: ' + genImages[count].path);
                                    } else {
                                        element[0].src = 'https://mexicovacations.com.mx/img/mvac_no-image.jpg';
                                    }
                                    
                                });
                            break;
                        }
                    }
                });
            }
        }

    }
})();
